export default "#LL_modal_mask{display:none;left:0;width:0;height:0;opacity:0;pointer-events:none}";